module.exports = __webpack_public_path__ + "static/media/orl3.png.f042054c.jpg";